import type { Router } from 'vue-router'
import { canNavigate } from '@layouts/plugins/casl'

export const setupGuards = (router: Router) => {
  let configLoaded = false

  // 👉 router.beforeEach
  // Docs: https://router.vuejs.org/guide/advanced/navigation-guards.html#global-before-guards
  router.beforeEach(async to => {
    /*
     * If it's a public route, continue navigation. This kind of pages are allowed to visited by login & non-login users. Basically, without any restrictions.
     * Examples of public routes are, 404, under maintenance, etc.
     */
    // 強制允許根路徑直接通過
    if (to.path === '/portal' ||to.path === '/' ||  to.meta.public) {
      return true
    }

    /**
     * Check if user is logged in by checking if token & user data exists in local storage
     * Feel free to update this logic to suit your needs
     */

    // 檢查用戶登入狀態（同步，必須在 await 之前）；過期 token 會自動清除
    const isLoggedIn = !!getValidUserToken()
    const baseUrl = import.meta.env.BASE_URL.replace(/\/$/, '') // 取得如 '/ath'

    // ⚠️ canNavigate 內部使用 inject()，必須在 await 之前呼叫，否則 Vue injection context 會遺失
    const hasAccess = !to.matched.length || canNavigate(to)

    // 👉 確保系統設定已載入（僅首次導航至非公開路由時取得，避免每次都呼叫 API）
    const drFsUrlStorage = useStorage('drFsUrl', '')
    if (!configLoaded || !drFsUrlStorage.value) {
      try {
        const resp = await useApi<any>(createUrl('/sys/getConfig'))
        const config = resp.data.value
        useStorage('compNo').value = config.compNo
        drFsUrlStorage.value = config.drFsUrl
        useStorage('oauth2Enable').value = config.oauth2Enable
        useStorage('buildVersion').value = config.buildVersion
        configLoaded = true
      } catch (e) {
        console.error('Failed to fetch system config:', e)
      }
    }

    if (to.meta.unauthenticatedOnly) {
      if (isLoggedIn){
        //  使用 cookie 確保有使用 login-linebot 重登過 (userToken 會有未過期但 session 己過期的狀況)
        if(to.name=='login-linebot'){
          if(useCookie('linebot').value===window.location.pathname){
            let target = new URLSearchParams(to.query['liff.state']).get("to")
            return target ? target : (baseUrl || '/')
          }else{
            return undefined
          }
        }
        return to.query.to ? to.query.to : (baseUrl || '/')
      }else{
        return undefined
      }
    }

    if (!isLoggedIn) {
      // 確保 redirectPath 包含完整的專案路徑，避免手機版跳到網域根目錄
      let redirectPath = to.fullPath
      if (!redirectPath.startsWith(baseUrl + '/') && redirectPath !== baseUrl) {
        // 如果路徑不包含 BASE_URL，則手動補上
        redirectPath = baseUrl + (to.fullPath.startsWith('/') ? to.fullPath : '/' + to.fullPath)
      }
      return { name: 'login', query: { to: redirectPath } };
    }

    if (!hasAccess) {
      return { name: 'not-authorized' }
    }
  })
}
